 <div class="form-item" [ngClass]="'form-field-'+fieldSubmission.field.type">
  <div class="field-label">
   <div>
      <strong >{{fieldSubmission.field.label}}</strong>
      <span class="form-ast" [hidden]="!fieldSubmission.field.mandatory"> * </span>
    </div>
  </div>
    <div class="field-multiple-choice-fill" [ngClass]="{'invalid-field': !valid && fieldSubmission.field.mandatory }">
      <ng-container *ngFor="let value of fieldSubmission.field.options.values">
        <core-helpers-forms-input-checkbox
          [label]="value"
          [name]="value"
          [defaultChecked]="isChecked(value)"
          [form]="form"
          (checkedChange)="onCheckedChange(value,$event)"
        ></core-helpers-forms-input-checkbox>
      </ng-container>
    </div>

</div>